var _excluded = ["children", "placement", "shouldWrapChildren", "tooltipLabel"],
  _excluded2 = ["placement", "tooltipLabel"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import { Tooltip as ChakraTooltip } from '@chakra-ui/react';
import useTheme from "../constants/theme/useTheme";
import { jsx as ___EmotionJSX } from "@emotion/react";
var Tooltip = _ref => {
  var {
      children,
      placement = 'top',
      shouldWrapChildren = false,
      tooltipLabel
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  var theme = useTheme();
  var {
    arrowShadowColor,
    color,
    shadowColor
  } = theme.components.Tooltip.baseStyle({});
  var boxShadow = "0px 0 5px " + shadowColor;
  var themeProps = {
    bg: 'white',
    boxShadow,
    borderRadius: '3px',
    color,
    fontSize: "" + theme.fontSizes.md,
    fontWeight: "" + theme.fontWeights.normal,
    maxW: '300px',
    padding: '13px 16px'
  };
  var tooltipAriaLabel = typeof tooltipLabel === 'string' ? tooltipLabel : '';
  return ___EmotionJSX(React.Fragment, null, tooltipLabel ? ___EmotionJSX(ChakraTooltip, _extends({
    "aria-label": tooltipAriaLabel,
    "data-testid": "sp-ui-tooltip",
    arrowShadowColor: arrowShadowColor,
    hasArrow: true,
    label: tooltipLabel,
    placement: placement,
    shouldWrapChildren: shouldWrapChildren
  }, themeProps, props), children) : ___EmotionJSX(React.Fragment, null, children));
};
export default Tooltip;
export function withTooltip(Component, shouldWrapChildren) {
  if (shouldWrapChildren === void 0) {
    shouldWrapChildren = false;
  }
  return _ref2 => {
    var {
        placement,
        tooltipLabel
      } = _ref2,
      props = _objectWithoutPropertiesLoose(_ref2, _excluded2);
    var component = ___EmotionJSX(Component, props);
    return ___EmotionJSX(Tooltip, {
      placement: placement,
      shouldWrapChildren: shouldWrapChildren,
      tooltipLabel: tooltipLabel
    }, component);
  };
}